module.exports = __webpack_public_path__ + "static/media/online-presence.1a2132dc.svg";